module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-3.7ce5a00f.jpg";